<template lang="pug">

  .biometric-approved-photo(v-if="data.approved")
    img(:src="data.imageUrl" :title="dataImagem" @click="this.redirecionarParaInfoDoDiaNaFolha")
    .approved-icon
      .icon-ptt-icons-check
    .buttons
      PButton(color="danger" size="md" @click="onActionButtonClick", :loading="loading")
        .icon-ptt-icons-X

  .biometric-photo(v-else)
    img(:src="data.imageUrl" :title="dataImagem" @click="redirecionarParaInfoDoDiaNaFolha")
    .biometric-photo-buttons
      PButton(color="success" size="md" @click="onActionButtonClick" :loading="loading") aprovar

</template>

<script>
import moment from 'moment'
export default {
  name: 'biometric-card',
  props: {
    data: {required: true},
    onClick: {required: true},
    empregado: {required: true}
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    mainClass () {
      return this.data.approved
    },
    dataImagem () {
      return new Date(this.data.createdWhen).toLocaleString('pt-BR')
    }
  },
  methods: {
    async onActionButtonClick () {
      this.loading = true
      try {
        await this.onClick(this.data)
      } catch (e) {
        console.warn(e)
      } finally {
        this.loading = false
      }
    },
    redirecionarParaInfoDoDiaNaFolha () {
      const idDoEmpregado = this.empregado.id
      const diaInicioFolha = this.empregado.closingDate
      const dataImagem = new Date(this.data.createdWhen)

      const dataInicial = new Date(dataImagem.getFullYear(), dataImagem.getMonth(), diaInicioFolha)
      let dataFinal = new Date(dataInicial)
      dataFinal = dataFinal.setDate(dataFinal.getDate() + 30)

      const dataInicialFormatada = moment(dataInicial).format('YYYY-MM-DD')
      const dataFinalFormatada = moment(dataFinal).format('YYYY-MM-DD')

      const numeroLinha = dataImagem.getDate() - diaInicioFolha

      this.$store.commit('sheet/lineActions/numeroLinhaAbrirInfo', numeroLinha)

      this.$router.replace({
        path: `/timesheet/employee/${dataInicialFormatada}/${dataFinalFormatada}/${idDoEmpregado}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.biometric-photo {
  position: relative;
  margin-bottom: 10px;
}
.biometric-photo img {
  height: 280px;
  margin-right: 10px;
}
.biometric-approved-photo {
  position: relative;
  margin-bottom: 20px;
}
.biometric-approved-photo img {
  height: 120px;
  margin-right: 10px;
  transition: height 0.2s;
}
.biometric-approved-photo .buttons {
  display: flex;
  position: absolute;
  bottom: -20px;
  width: 100%;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  left: -5px;
  opacity: 0;
  transition: opacity 0.3s;
}
.biometric-approved-photo:hover .buttons {
  opacity: 1;
}
.biometric-photo-buttons {
  position: absolute;
  bottom: 5px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  left: -5px;
}
.approved-icon {
  position: absolute;
  left: 5px;
  font-size: 1.6em;
  top: 5px;
  color: #0c9b73;
  text-shadow: 0px 2px black;
}
</style>
